import React from 'react';
import ReactDOM from 'react-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getGlobalDictionaryTerm } from '../../utils';
const ALERT_BANNER = 'alertBanner';
const CloseIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12.974",
  height: "12.974"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "m11.207,0.707l1.06,1.06l-4.72,4.72l4.72,4.72l-1.06,1.06l-4.72,-4.72l-4.72,4.72l-1.06,-1.06l4.72,-4.72l-4.72,-4.72l1.06,-1.06l4.72,4.72l4.72,-4.72z"
}));
const Banner = _ref => {
  let {
    text
  } = _ref;
  const [showAlertBanner, setShowAlertBanner] = React.useState(true);
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const btnLabel = getGlobalDictionaryTerm(sitecoreContext, 'closeAnnouncementBannerLabel') || 'Close announcement banner';
  const btnTitle = getGlobalDictionaryTerm(sitecoreContext, 'close') || 'close';
  return showAlertBanner ? /*#__PURE__*/React.createElement("div", {
    "aria-label": "Alert Banner",
    role: "banner",
    className: "container d-print-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alertBanner__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alertBanner__text",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "alertBanner__button"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => setShowAlertBanner(false),
    "aria-label": btnLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "accessibility-hidden-text"
  }, btnLabel), /*#__PURE__*/React.createElement(CloseIcon, null)))))) : /*#__PURE__*/React.createElement("div", null);
};
const AnnouncementBanner = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const text = get(fields, 'data.item.text.jss.value');
  const [banner, setBanner] = React.useState(null);
  React.useEffect(() => {
    let bn;
    if (typeof window !== 'undefined') {
      bn = document.getElementById('announcement-banner');
      setBanner(bn);
      // hide inline banner using css style:
      // .alertBanner + .alertBanner {
      //   display: none;
      // }
      if (text && bn) {
        bn.classList.add(ALERT_BANNER);
        bn.classList.add(params.Color);
      }
    }
    return () => {
      bn && bn.classList.remove(ALERT_BANNER);
      bn && bn.classList.remove(params.Color);
    };
  }, []);
  return banner && text ? /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement(Banner, {
    text: text
  }), banner) : null;
};
export default AnnouncementBanner;